import React from 'react'
import DatePicker from 'react-datepicker'

const Datepicker = ({ onChange, name, value, selected }) => {
  return (
    <DatePicker
      selected={selected}
      onChange={onChange}
      name={name}
      showWeekNumbers
      className="form-control"
      dateFormat="dd.MM.yyyy"
    />
  )
}

export default Datepicker
